var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatherCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.752,
    height: 17.28,
    viewBox: "0 0 15.752 17.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-calendar",
    "data-name": "Icon feather-calendar",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M6.028,6h10.7a1.528,1.528,0,0,1,1.528,1.528v10.7a1.528,1.528,0,0,1-1.528,1.528H6.028A1.528,1.528,0,0,1,4.5,18.224V7.528A1.528,1.528,0,0,1,6.028,6Z",
    transform: "translate(-4.5 -4.472)",
    fill: "none",
    stroke: "#f8f8f8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M24,3V6.056",
    transform: "translate(-14.068 -3)",
    fill: "none",
    stroke: "#f8f8f8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M12,3V6.056",
    transform: "translate(-8.18 -3)",
    fill: "none",
    stroke: "#f8f8f8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M4.5,15H18.252",
    transform: "translate(-4.5 -8.888)",
    fill: "none",
    stroke: "#f8f8f8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherCalendar);
export default __webpack_public_path__ + "static/media/feather-calendar.66ee7315214fda77dc2a63e97f60db0f.svg";
export { ForwardRef as ReactComponent };